import { render, staticRenderFns } from "./Domains.vue?vue&type=template&id=c9f5de6a&"
import script from "./Domains.vue?vue&type=script&lang=js&"
export * from "./Domains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fmandrakey%2FProjects%2Ftwi-dyndns%2Fmanager%2Ffrontend%2Fsrc%2Fviews%2FDomains.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/lang/domains.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Fmandrakey%2FProjects%2Ftwi-dyndns%2Fmanager%2Ffrontend%2Fsrc%2Fviews%2FDomains.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports